import { render, staticRenderFns } from "./upload-score.vue?vue&type=template&id=805ac6c2&scoped=true&"
import script from "./upload-score.vue?vue&type=script&lang=js&"
export * from "./upload-score.vue?vue&type=script&lang=js&"
import style0 from "./upload-score.vue?vue&type=style&index=0&id=805ac6c2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "805ac6c2",
  null
  
)

export default component.exports